var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
const SvgGemH4 = props => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  width: 24,
  height: 24,
  viewBox: "0 0 24 24",
  role: "img"
}, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
  fill: "#FF3CA0",
  fillRule: "evenodd",
  d: "M20.928 19v-2.07h1.07v-1.874h-1.07V9H18.49l-3.297 6.252v1.68h3.969V19zm-1.766-3.944h-2.24l2.24-4.168zm-5.322 3.939V5h-2.822v5.497H4.802V5H2v13.995h2.802v-5.896h6.216v5.896z"
})));
export default SvgGemH4;